export type SortDirection = "asc" | "desc";

export interface SortConfig {
  field: string;
  direction: SortDirection;
}

// Use lowercase field names to match frontend data structure
export type SortableFields =
  | "willBeReadyFrom"
  | "willBeReadyTo"
  | "userFirstName"
  | "userSecondName"
  | "lbo"
  | "status"
  | "therapyTaken"
  | "created"
  | "modified";

export interface ColumnSortConfig {
  field: SortableFields;
  label: string;
  sortable: boolean;
  defaultDirection?: SortDirection;
}

// Default sort - defined here to avoid import cycling
export const DEFAULT_SORT: SortConfig = {
  field: "willBeReadyFrom",
  direction: "asc",
};

export const SORTABLE_FIELDS: SortableFields[] = [
  "willBeReadyFrom",
  "willBeReadyTo",
  "userFirstName",
  "userSecondName",
  "lbo",
  "status",
  "therapyTaken",
  "created",
  "modified",
];
